import { useParams } from "react-router-dom";
import BookingIntegrationShell from "@/components/integrations/BookingIntegrationShell";
import NoIndex from "@/components/NoIndex";

export default function EmbeddedBooking() {
  const { integrationId } = useParams();
  return <><NoIndex /><BookingIntegrationShell identifier={integrationId} embedded /></>;
}
